// Parâmetros do sistema oferecidos nos modelos. `liquid` é renderizado pelo servidor
// no envio (Liquidable); `name` é a variável nomeada usada nos templates da Meta.
export const SYSTEM_PARAMETERS = Object.freeze([
  { name: 'nome', label: 'Nome do contato', liquid: '{{ contact.name }}' },
  {
    name: 'primeiro_nome',
    label: 'Primeiro nome',
    liquid: '{{ contact.first_name }}',
  },
  { name: 'sobrenome', label: 'Sobrenome', liquid: '{{ contact.last_name }}' },
  {
    name: 'telefone',
    label: 'Telefone do contato',
    liquid: '{{ contact.phone_number }}',
  },
  { name: 'email', label: 'E-mail do contato', liquid: '{{ contact.email }}' },
  {
    name: 'nome_agente',
    label: 'Nome do atendente',
    liquid: '{{ agent.name }}',
  },
  { name: 'canal', label: 'Canal de atendimento', liquid: '{{ inbox.name }}' },
  { name: 'empresa', label: 'Nome da empresa', liquid: '{{ account.name }}' },
]);

// Mesmos exemplos que o servidor envia à Meta (MessageTemplateManagementService).
const EXAMPLES = Object.freeze({
  nome: 'Maria Oliveira',
  primeiro_nome: 'Maria',
  sobrenome: 'Oliveira',
  telefone: '+55 11 99999-9999',
  email: 'maria@exemplo.com.br',
  nome_agente: 'Ana Souza',
  canal: 'WhatsApp',
  empresa: 'Minha Empresa',
});
export const systemParameterExample = name =>
  EXAMPLES[String(name).toLowerCase()];

// Insere o texto na posição do cursor do campo (ou no fim, sem campo focado).
export const insertAtCursor = (value, token, element) => {
  const text = String(value || '');
  const start = element?.selectionStart ?? text.length;
  const end = element?.selectionEnd ?? text.length;
  const before = text.slice(0, start);
  const spacer = before && !/\s$/.test(before) ? ' ' : '';
  return {
    value: `${before}${spacer}${token}${text.slice(end)}`,
    caret: start + spacer.length + token.length,
  };
};
